

// Change THIS string to swap theme globally:
export const THEMES = {
	clinicalCool: {
		primary: "#6B7FA0",
		palette: ["#4E6B8A", "#7B92B0", "#A3B4C8", "#C8D1DC", "#8FA0B8", "#D9E0E8"],
		dim: "#F4F6F9",
	},

	mutedTeal: {
		primary: "#8FB4B0",
		palette: ["#A5C4C1", "#BCD7D4", "#D1E6E4", "#E1F0EF", "#EAF5F4", "#F1F8F7"],
		dim: "#F1F8F7",
	},

	monoSoft: {
		primary: "#9AA2AE",
		palette: ["#B0B6C0", "#C6CAD2", "#DADDE3", "#E7E9ED", "#EFF1F4", "#F4F5F7"],
		dim: "#F4F5F7",
	},

	mutedOrange: {
		primary: "#D9A77E",
		palette: ["#E3BA9B", "#ECCDB5", "#F3DDD0", "#F8EAE1", "#FAF1EB", "#FCF5F1"],
		dim: "#FCF5F1",
	},

	softPurple: {
		primary: "#bbb2de",
		palette: ["#C2BBE1", "#D4CFEA", "#E3DFF2", "#EEEAF7", "#F3F1FA", "#F7F6FC"],
		dim: "#F7F6FC",
	},
};


export const CATEGORY_THEME = {
	"treatment-characteristics": "softPurple",
	"patient-characteristics": "mutedTeal",
	"manuscript-characteristics": "monoSoft",
};

// fallback if category missing/unknown
export const DEFAULT_THEME_NAME = "monoSoft";

export function getFacetTheme(category) {
	const name = CATEGORY_THEME[category] || DEFAULT_THEME_NAME;
	return THEMES[name] || THEMES[DEFAULT_THEME_NAME];
}
